function VideoPlayer({ src, className, width = "100%", height = "100%", autoPlay = false, loop = false, muted = false, controls = true }) {
  return (
    <video
      className={className}
      width={width}
      height={height}
      controls={controls}
      autoPlay={autoPlay}
      loop={loop}
      muted={muted}
      playsInline
      style={{ backgroundColor: "#000" }}
    >
      <source src={src} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
}

export default VideoPlayer;
